// src/components/PageTracker.js
import usePageTracking from "./usePageTracking";
 
export default function PageTracker({ children }) {
  usePageTracking();
  return children;
}
